import * as api from 'bc-artifacts-client/api';
import { metrics } from 'bc-metrics';
import { logClientEvent } from 'utils/metrics/logClientEvent';

const createBrief = async (
  ...args: Parameters<typeof api.createBrief>
): ReturnType<typeof api.createBrief> => {
  const req = args[0];
  logClientEvent({
    name: 'brief.created',
    key: req.key,
    title: req.title,
    discoverable: req.discoverable,
    ownerPrincipal: req?.ownerPrincipal,
    description: req.description,
  });
  return api.createBrief(...args);
};

const createOrUpdateBriefAccess = async (
  ...args: Parameters<typeof api.createOrUpdateBriefAccess>
): ReturnType<typeof api.createOrUpdateBriefAccess> => {
  const [, { briefId, role, principal }] = args;
  logClientEvent({
    name: 'brief.invite',
    briefId,
    principalType: principal.principalType,
    principalId: principal.principalId,
    role,
  });
  metrics.incrementTimeSeriesCounter('brief.invite', {
    method: 'brief.invite',
    path: 'briefs',
    type: role,
  });
  return api.createOrUpdateBriefAccess(...args);
};

export {
  briefValidationSchema,
  checkStarterPlanExists,
  bulkCreateOrUpdateBriefAccess,
  deleteBrief,
  retrieveArtifactFavorites,
  updateArtifactFavorites,
  deleteBriefAccess,
  deleteOwnBriefAccess,
  restoreTrashedArtifact,
  retrieveAccessibleBriefIds,
  retrieveBrief,
  retrieveBriefAccess,
  retrieveBriefArtifacts,
  retrieveBriefById,
  retrieveBriefs,
  retrieveBriefsStats,
  retrieveGlobalTemplateBriefs,
  retrieveOwnBriefs,
  retrieveReferencedBriefs,
  retrieveStarterPlan,
  retrieveTrashedArtifacts,
  searchTeamGroups,
  searchTeamOrganizations,
  searchTeamUsers,
  setStarterPlan,
  trimBriefPayload,
  trimNewBriefPayload,
  updateBrief,
} from 'bc-artifacts-client/api';
export type {
  ArtifactFavoriteKey,
  BriefWithOwner,
  BriefAccessSavedType,
  BriefAccessType,
  ContractPrincipal,
  BulkAccessMember,
  BulkAccessResult,
  BriefCollectionType,
  BriefNewType,
  BriefSavedType,
  BriefType,
  BriefWithOwnerCollectionType,
  Favorite,
  ListNodeTreeHydratedType,
  ReferencedBriefType,
} from 'bc-artifacts-client/api';

export { createBrief, createOrUpdateBriefAccess };
